var render = function render(){var _vm=this,_c=_vm._self._c;return _c('BarLoader',{staticClass:"m-auto",attrs:{"color":'#343a40',"width":240,"height":8,"loading":true}})
}
var staticRenderFns = []

export { render, staticRenderFns }